const state = {
  remainData: null,
}

const getters = {
}

const mutations = {
  setRemainData (state, v) {
    state.remainData = v
  }
}

const actions = {
  search ({ state, commit, rootState }, params) {
    return rootState.axios.get('/festival/v1frontend/gambling-cake/search', { params })
  },
  // create ({ state, commit, rootState }, params) {
  //   return rootState.axios.post('/festival/v1frontend/gambling-cake/create', params)
  // },
  create ({ state, commit, rootState }, params) {
    return rootState.axios.post('/festival/v1frontend/gambling-cake/create-prize-creditdg-2024', params)
  },
  remainRewardCreditdgs ({ state, commit, rootState }, params) {
    return rootState.axios.post('/festival/v1frontend/gambling-cake/remain-reward-creditdgs', params)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
